import { combineReducers } from "@client/lib/misc";
import { type WidgetsAppState } from "../types";
import header, { initialState as initialStateHeader } from "./Header/reducer";
import sidePanel, { initialState as initialStateSidePanel } from "./SidePanel/reducer";

export const initialState: WidgetsAppState = {
  header: initialStateHeader,
  sidePanel: initialStateSidePanel
};
export const reducers = {
  header,
  sidePanel
};
export default combineReducers<WidgetsAppState>(reducers);
